import { DELIVERY_STATES } from '../../../lib/deliveryStates';

// The delivery states a manual pickup confirmation may transition from. Matched
// case-insensitively (the wire is lowercase; older fixtures are TitleCase). Fail closed:
// an unrecognized state is not confirmable — never offer the action on a state we do not
// understand. Spellings come from the canonical constants (backend-confirmed underscores);
// the legacy hyphen/space variants are rejected on purpose rather than guessed.
const CONFIRMABLE_STATES = new Set<string>([
  DELIVERY_STATES.stored,
  DELIVERY_STATES.expired,
  DELIVERY_STATES.rejected,
  DELIVERY_STATES.nonCollected,
  DELIVERY_STATES.blocked,
]);

export function isConfirmable(status: string): boolean {
  return CONFIRMABLE_STATES.has(status.toLowerCase());
}
